import {
  IS_LOADING,
  API_URL,
  GET_ERRORS,
  GET_CONFIGURATIONS_MAP,
} from "./types";
import axios from "axios";
import { tokenConfig } from "../utils/tokenConfig";
import SuccessAlert from "../components/Modals/SuccessAlert";

export const getConfigurationsMap = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API_URL}/params/simulation/`, tokenConfig());
    dispatch({
      type: GET_CONFIGURATIONS_MAP,
      payload: res.data,
    });
  } catch (err) {
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};

export const updateConfigurationsMap = (listRows) => async (dispatch) => {
  try {
    dispatch({
      type: IS_LOADING,
    });
    const body = JSON.stringify(listRows);
    const res = await axios.post(
      `${API_URL}/params/simulation/`,
      body,
      tokenConfig()
    );
    dispatch({
      type: GET_CONFIGURATIONS_MAP,
      payload: res.data,
    });
    dispatch({
      type: IS_LOADING,
    });
    SuccessAlert("Maps updated successfully!");
  } catch (err) {
    dispatch({
      type: IS_LOADING,
    });
    const errors = {
      msg: err.response.data,
      status: err.response.status,
    };
    dispatch({
      type: GET_ERRORS,
      payload: errors,
    });
  }
};
